// Re-exports `throttle-debounce` to be added in the export registry.

import {  throttle } from 'throttle-debounce';
export {  throttle }
import {  debounce  } from 'throttle-debounce';
export {  debounce  };
flarum.reg.add('core', 'common/utils/throttleDebounce', { throttle: throttle,debounce: debounce, });